<template>
  <div class="step">
    <div class="step-time">
      <div class="step-time-start">
        {{ step.start }}
      </div>
      <div class="step-time-line">
        <div class="step-time-line-element">

        </div>
      </div>
      <div class="step-time-end">
        {{ step.end }}
      </div>
    </div>
    <div class="step-info">
      <div class="step-level">
        {{ step.level }}
      </div>
      <div class="step-position">
        {{ step.position }}
      </div>
      <div v-for="(work, i) in step.works" :key="i">
        <div class="step-description">
          {{ work.description }}
        </div>
        <career-element-work :work="work" />
      </div>
    </div>
  </div>
</template>

<script>
import CareerElementWork from "./CareerElementWork";
export default {
  name: "CareerElementSteps",
  props: {
    step: Object,
  },
  components: {
    CareerElementWork
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/mixins";

.step {
  position: relative;
  display: flex;
  &-level {
    @include bubble;
    background-color: #26ade4;
    top: 0;
    right: 0;
    position: absolute;
    -webkit-transform: rotate(20deg);
    -moz-transform: rotate(20deg);
    -o-transform: rotate(20deg);
    -ms-transform: rotate(20deg);
    transform: rotate(20deg);
  }
  &-position {
    font-weight: 700;
    font-size: 20px;
    margin: 10px 0;
  }
  &-description {
    font-size: 18px;
  }
  &-time {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 200px;
    &-start {
      font-size: 18px;
      text-align: center;
      height: 30px;
    }
    &-line {
      display: flex;
      justify-content: center;
      height: calc(100% - 60px);
      &-element {
        width: 5px;
        background-color: #26ade4;
        border-radius: 4px;
      }
    }
    &-end {
      font-size: 18px;
      text-align: center;
      height: 30px;
    }
  }
  &-info {
    width: calc(100% - 200px);
  }
}

@media only screen and (max-width : 768px) {
  .step {
    flex-direction: column;
    &-time {
      display: flex;
      flex-direction: row;
      justify-content: normal;
      width: 100%;
      height: 60px;
      &-start {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100%;
      }
      &-end {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100%;
      }
      &-line {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 200px);
        height: 100%;
        &-element {
          width: 100%;
          height: 5px;
        }
      }
    }
    &-info {
      width: 100%;
    }
    &-level {
      top: 60px;
      -webkit-transform: rotate(10deg);
      -moz-transform: rotate(10deg);
      -o-transform: rotate(10deg);
      -ms-transform: rotate(10deg);
      transform: rotate(10deg);
    }
  }
}
</style>